"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CategoryCodePUBH = function CategoryCodePUBH(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 16 16"
  }, props), _react.default.createElement("g", null, _react.default.createElement("title", null, "CategoryCodePUBH"), _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M11.2,8.947a.529.529,0,0,1-.5-.358l-.331-.968-1.836,4.5a.529.529,0,0,1-.49.33H8a.529.529,0,0,1-.478-.39L6.047,6.622l-.794,2.1a.529.529,0,0,1-.5.342H2.437a5.664,5.664,0,0,0,11.149-.112Z"
  }), _react.default.createElement("path", {
    d: "M4.392,8,5.636,4.722a.529.529,0,0,1,1.006.049l1.5,5.505L9.916,5.912a.529.529,0,0,1,.991.029l.666,1.947h2.09A5.664,5.664,0,0,0,2.337,8Z"
  }))));
};

var _default = CategoryCodePUBH;
exports.default = _default;